/**
 * 计算图片在 object-fit: contain 下的实际渲染宽高
 * @param {number} containerWidth - 容器宽度
 * @param {number} containerHeight - 容器高度
 * @param {number} imageWidth - 图片原始宽度
 * @param {number} imageHeight - 图片原始高度
 * @returns {{ width: number, height: number }} 实际渲染宽高
 */
export function getContainedImageSize(
  containerWidth: number,
  containerHeight: number,
  imageWidth: number,
  imageHeight: number
) {
  if (imageWidth <= 0 || imageHeight <= 0)
    return { width: 0, height: 0, top: 0, left: 0 };

  const containerRatio = containerWidth / containerHeight;
  const imageRatio = imageWidth / imageHeight;

  let width: number, height: number;
  let top = 0;
  let left = 0;

  if (imageRatio > containerRatio) {
    // 图片更宽，以宽度为基准缩放
    width = Math.min(containerWidth, imageWidth);
    height = Math.min(containerWidth / imageRatio, imageHeight);
  } else {
    // 图片更高，以高度为基准缩放
    height = Math.min(containerHeight, imageHeight);
    width = Math.min(containerHeight * imageRatio, imageWidth);
  }
  top = (containerHeight - height) / 2;
  left = (containerWidth - width) / 2;

  return { width, height, top, left };
}

export function getObjectFitContainSize(
  containerWidth: number,
  containerHeight: number,
  imageWidth: number,
  imageHeight: number
) {
  if (imageWidth <= 0 || imageHeight <= 0)
    return { width: 0, height: 0, top: 0, left: 0 };

  const containerRatio = containerWidth / containerHeight;
  const imageRatio = imageWidth / imageHeight;

  let width: number, height: number;
  let top = 0;
  let left = 0;

  if (imageRatio > containerRatio) {
    // 图片更宽，以宽度为基准缩放
    width = containerWidth;
    height = containerWidth / imageRatio;
    top = (containerHeight - height) / 2;
  } else {
    // 图片更高，以高度为基准缩放
    height = containerHeight;
    width = containerHeight * imageRatio;
    left = (containerWidth - width) / 2;
  }

  return { width, height, top, left };
}
